// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

// Import third party modules
import angular from 'angular';

const MODULE_NAME = 'prettyFocus';
angular.module(MODULE_NAME, [])

    .run(() => {

      const element = document.body;
      const restrictedTypes = ['mouse', 'touch'];
      const restrictClass = 'focus-disabled';
      let interactLock = false;
      let inputType = 'mouse';

      function interact(e) {
        if (!interactLock) {
          switch (e.type) {
            case 'mousedown':
              interactLock = false;
              inputType = 'mouse';
              break;
            case 'touchstart':
              interactLock = true;
              inputType = 'touch';
              break;
            default:
            case 'keydown':
              inputType = 'keyboard';
              break;
          }
        }
      }

      function preFocus() {
        for (var i = 0; i < restrictedTypes.length; i++) {
          if (inputType === restrictedTypes[i]) {
            addClass(element, restrictClass);
            break;
          }
        }
      }

      function preBlur() {
        removeClass(element, restrictClass);
      }

      function hasClass(el, className) {
        return new RegExp(' ' + className + ' ').test(' ' + el.className + ' ');
      }

      function addClass(el, className) {
        if (!hasClass(el, className)) {
          el.className += ' ' + className;
        }
      }

      function removeClass(el, className) {
        var newClass = ' ' + el.className.replace(/[\t\r\n]/g, ' ') + ' ';
        if (hasClass(el, className)) {
          while (newClass.indexOf(' ' + className + ' ') >= 0) {
            newClass = newClass.replace(' ' + className + ' ', ' ');
          }
          el.className = newClass.replace(/^\s+|\s+$/g, '');
        }
      }

      element.addEventListener('mousedown', interact);
      element.addEventListener('touchstart', interact);
      element.addEventListener('keydown', interact);
      element.addEventListener('focus', preFocus, true);
      element.addEventListener('blur', preBlur, true);
    });

export default MODULE_NAME;
